import React, { useState, useEffect } from "react";
import ReportAPIService from "../api/reports.api";

export default function MonthlyPage1({
  campaign,
  monthlyDate,
  companyName,
  previewRefPage1,
  previewHtml,
}) {
  const [logo, setLogo] = useState("");
  const date = new Date(campaign[0].sendTime);
  const [audienceName, setAudienceName] = useState("");

  useEffect(() => {
    async function fetchCompanies() {
      try {
        const [errorCompanies, fetchedCompanies] =
          await ReportAPIService.GetCompanies();
        if (errorCompanies) {
          console.error("Error fetching companies:", errorCompanies);
        }
        setAudienceName(
          fetchedCompanies.find((company) => company.code === companyName)
            ?.name || ""
        );
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    }

    fetchCompanies();
  }, [companyName]);

  useEffect(() => {
    if (previewRefPage1.current && previewRefPage1.current.innerHTML === "") {
      previewRefPage1.current.innerHTML = previewHtml;
    }
  }, [previewRefPage1, previewHtml]);

  useEffect(() => {
    async function getLogo() {
      const [error, imageName] = await ReportAPIService.GetCompanyImage(
        companyName
      );
      if (error) {
        console.error("Error fetching company image:", error);
      }
      setLogo(`/images/${imageName}`);
    }

    if (logo === "") {
      getLogo();
    }
  }, [companyName, logo]);

  function changeDate(date) {
    const day = date.getDate();
    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ][date.getMonth()];
    const year = date.getFullYear();

    let dayString = day.toString();
    let suffix = "";

    if (
      dayString.length === 1 ||
      (dayString.length > 1 && dayString.charAt(dayString.length - 2) !== "1")
    ) {
      switch (dayString.charAt(dayString.length - 1)) {
        case "1":
          suffix = "st";
          break;
        case "2":
          suffix = "nd";
          break;
        case "3":
          suffix = "rd";
          break;
        default:
          suffix = "th";
          break;
      }
    } else {
      suffix = "th";
    }

    const formattedDate = `${day}${suffix} ${month} ${year}`;
    return formattedDate;
  }

  function changeDate2(date) {
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    if (month === "01") month = "January";
    else if (month === "02") month = "February";
    else if (month === "03") month = "March";
    else if (month === "04") month = "April";
    else if (month === "05") month = "May";
    else if (month === "06") month = "June";
    else if (month === "07") month = "July";
    else if (month === "08") month = "August";
    else if (month === "09") month = "September";
    else if (month === "10") month = "October";
    else if (month === "11") month = "November";
    else if (month === "12") month = "December";
    var year = date.getFullYear().toString();
    return `${month} ${year}`;
  }

  function main() {
    return (
      <>
        <div className="row content">
          <div className="col-md-6 left-side">
            <div className="row title">
              <div>
                <h1
                  className="heading"
                  style={{
                    fontSize: "5.4vh",
                  }}
                >
                  NEWSLETTER
                </h1>
              </div>
              <div>
                <h1
                  className="heading"
                  style={{
                    fontSize: "5.4vh",
                  }}
                >
                  REPORT
                </h1>
              </div>
              <br />
              <img
                src={logo}
                className={companyName === "system7" ? "system7-logo" : ""}
                alt="Client Logo"
                style={{
                  height: "auto",
                  width: "auto",
                  maxWidth: "50vh",
                  minHeight: "7vh",
                  maxHeight: "15vh",
                }}
              />
            </div>
            <div className="sub-title">
              <div className="heading-subheading">
                <h4 className="heading">Campaign: </h4>
                <h4 className="sub-heading">
                  {changeDate2(date)} Team Newsletter
                </h4>
              </div>
              <div className="heading-subheading">
                <h4 className="heading">Audience: </h4>
                <h4 className="sub-heading">{audienceName} New Zealand Database</h4>
              </div>
              <div className="heading-subheading">
                <h4 className="heading">Delivery Date: </h4>
                <h4 className="sub-heading">{changeDate(date)}</h4>
                <br />
                <br />
                <br />
                <br />
              </div>
              <h4 className="heading">
                Report prepared for{" "}
                {companyName === "mtp" ? "Mark Trafford" : "Cobus Ferreira"},{" "}
                {changeDate(monthlyDate)}
              </h4>
            </div>
          </div>
          <div className="col-md-6 right-side">
            <div className="previewHtml">
              <img
                src={"/images/phone.png"}
                alt="Phone"
                style={{
                  width: "19vw",
                  height: "100%",
                  position: "absolute",
                  top: "0",
                  right: "0",
                }}
              />
              <div className="campaign-preview">
                <div ref={previewRefPage1} id="campaign-preview-id" />
              </div>
            </div>
            <div className="circle"></div>
          </div>
        </div>
        <img
          className="hitsend-logo "
          src={"/images/HitSend-logo.png"}
          alt="HitSend Logo"
        />
      </>
    );
  }

  return <>{main()}</>;
}
